import CustomModal from "shared/components/modal/CustomModal";
import TabelaVisualizarProcessosJudiciaisHistoricos from "./TabelaVisualizarProcessosJudiciaisHistoricos";

interface ModalVisualizarProcessoJudicialHistoricoProps {
  showModal: boolean;
  processoId: number | null | undefined;
  onCloseModal: () => void;
}

const ModalVisualizarProcessoJudicialHistorico: React.FC<ModalVisualizarProcessoJudicialHistoricoProps> = (props) => {
  return (
    <CustomModal
      key={"modal-visualizar-processo-judicial-historico"}
      titulo="Histórico do processo"
      onCloseModal={() => props.onCloseModal()}
      size="lg"
      tipoModal="MODAL_LATERAL"
      fecharModalAoClicarFora
      showModal={props.showModal}
      scrollable
    >
      <TabelaVisualizarProcessosJudiciaisHistoricos processoId={props.processoId} />
    </CustomModal>
  );
};

export default ModalVisualizarProcessoJudicialHistorico;
